import TextInfo from '@/components/datainfo/TextInfo'

import {
  cmdTypeRequest
} from '@/api'

let formParms = [{
  type: 'input',
  label: '名称',
  key: 'name',
  check: {
    required: true
  }
},
{
  type: 'textarea',
  label: '所需文件名称',
  key: 'filename'
},
{
  type: 'textarea',
  label: '执行命令',
  key: 'cmdInfo'
},
{
  type: 'textarea',
  label: '检查命令',
  key: 'checkInfo'
},
{
  type: 'textarea',
  label: '默认配置',
  key: 'defaultConfig'
}]

export const cmdTypeList = function (parm = {}) {
  let config = {
    key: parm.key || 'request_type',
    titleConfig: {
      title: parm && parm.title ? parm.title : '命令模版',
      titleMenus: parm && parm.titleMenus ? parm.titleMenus : [{
        key: 'add',
        label: '新增'
      }]
    },
    listConfig: {
      listMenus: parm && parm.listMenus ? parm.listMenus : [{
        key: 'edit',
        label: '修改'
      },
      {
        key: 'del',
        label: '删除'
      }],
      config: cmdType(),
      getTitle: (data) => {
        return data.name
      }
    },
    async getData (dataParm) {
      let data = await cmdTypeRequest.get({id: dataParm && dataParm.id ? dataParm.id : null})
      data.forEach((item) => {
        item.__showNum = 0
      })
      return data
    },
    updateConfig: {
      title: '命令模版',
      request: cmdTypeRequest,
      getFormParms () {
        return formParms
      }
    }
  }
  return config
}

export const cmdType = function () {
  let config = {
    getInfoParm: () => {
      return [{
        comp: TextInfo,
        config: {
          infoParm: [{
            label: '名称',
            field: 'name'
          },
          {
            label: '所需文件名称',
            field: 'filename'
          },
          {
            label: '执行命令',
            field: 'cmdInfo'
          },
          {
            label: '检查命令',
            field: 'checkInfo'
          },
          {
            label: '默认配置',
            field: 'defaultConfig'
          }]
        }
      }]
    }
  }
  return config
}
